import { Store } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconStore(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Store />
    </IconWrapper>
  );
}
